/* eslint no-underscore-dangle: [error, { allow: [_id] }] */
/* global globals */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import MatchesStore from '../../stores/MatchesStore';
import MatchesActionCreators from '../../actions/MatchesActionCreators';
// import MemberProfile from '../../components/member/MemberProfile';
import VoteButtons from '../../components/matches/VoteButtons';
import SectionSwitch from '../../components/matches/SectionSwitch';
import MemberQuestionsBlock from '../../components/member/MemberQuestionsBlock';
import MatchesFooter from '../../components/matches/MatchesFooter';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

import MemberProfileCarousel from '../../components/member/MemberProfileCarousel';

class MatchesSearchMemberContainer extends Component {
  state = {
    member: MatchesStore.getSearchMember(),
    loading: MatchesStore.getLoading(),
    nextLoading: MatchesStore.getNextSearchMemberLoading(),
    noAboLimitReached: MatchesStore.getNoAboLimitReached(),
    section: 'images',
    newMatch: null,
  };

  sectionInner = React.createRef();

  componentDidMount() {
    MatchesStore.addChangeListener(this.onChange);
  }

  componentWillUnmount() {
    MatchesStore.removeChangeListener(this.onChange);
  }

  onChange = () => {
    const member = MatchesStore.getSearchMember();
    const nextLoading = MatchesStore.getNextSearchMemberLoading();
    const newMatch = MatchesStore.getNewMatch();

    const { member: oldMember } = this.state;
    let { section } = this.state;
    if (member && member !== oldMember && get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint) {
      section = null;
    }

    this.setState({
      member,
      loading: MatchesStore.getLoading(),
      nextLoading,
      noAboLimitReached: MatchesStore.getNoAboLimitReached(),
      section,
      newMatch,
    });

    const nextSearchMember = MatchesStore.getNextSearchMember();

    if (!member && nextSearchMember) {
      MatchesStore.setSearchMember(nextSearchMember);
      MatchesStore.setNextSearchMember(null);
      MatchesStore.setNextSearchMemberLoading(true);
      MatchesStore.emitChange();

      MatchesActionCreators.loadSearchMatchesMember('', nextSearchMember._id);
    }

    if (member && !nextSearchMember && !nextLoading) {
      MatchesStore.setNextSearchMemberLoading(true);
      MatchesStore.emitChange();

      MatchesActionCreators.loadSearchMatchesMember('', member._id);
    }
  };

  handleSectionSwitch = (section, e) => {
    const { section: currentSection } = this.state;
    if (currentSection === section && get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint) {
      this.setState({ section: null });
      e.currentTarget.blur();
      return;
    }

    this.setState({ section });

    this.sectionInner.current.scrollTop = 0;

    e.currentTarget.blur();
  };

  handleVote = (vote) => {
    const { member } = this.state;

    MatchesStore.setLoading(true);
    MatchesStore.emitChange();

    MatchesActionCreators.matchesVote(member._id, vote);
  };

  render() {
    const {
      member,
      loading,
      nextLoading,
      noAboLimitReached,
      section,
      newMatch,
    } = this.state;

    const {
      myId,
      myImage,
      needAbo,
      verificationRestrictions,
    } = this.props;

    //
    if (!member && (loading || nextLoading)) {
      return (
        <div className="block pam">
          <div className="loading">
            <div className="loading-spinner loading-spinner--vcenter" />
          </div>
        </div>
      );
    }

    //
    if (!member) {
      return (
        <div>
          <div className="block pam">
            <div className="membersBlock block-title">
              Nav atrasti kritērijiem atbilstoši lietotāji
            </div>
          </div>
          <MatchesFooter />
        </div>
      );
    }

    const renderSection = () => {
      if (!['my', 'looking'].includes(section)) {
        return (null);
      }

      if (section === 'images') {
        return (
          <view style={{ marginBottom: 20, display: 'block' }} />
        );
      }

      return (
        <MemberQuestionsBlock
          key={member._id}
          memberId={member._id}
          section={section}
        />
      );
    };

    const compact = section === 'my' || section === 'looking';

    //
    return (
      <div>
        <div className={`block mbm pam${loading ? ' loading' : ''}`}>
          {loading && (
            <div className="loading-spinner loading-spinner--vcenter" />

          )}

          <div className="">
            <MemberProfileCarousel
              id={member._id}
              memberId={member._id}
              name={member.name}
              image={member.image}
              sex={member.sex}
              myId={myId}
              myImage={myImage}
              needAbo={needAbo}
              verificationRestrictions={verificationRestrictions}
              compact={compact}
            />

            <SectionSwitch
              onSwitch={this.handleSectionSwitch}
              active={section}
              percent={member.answer_score}
              name={member.name}
              id={member._id}
              age={member.age}
              location={member.location}
              verified={member.verified}
            />
          </div>
          <div className="mtm">
            <VoteButtons
              active={newMatch ? 'like' : null}
              onVote={this.handleVote}
              noAboLimitReached={noAboLimitReached}
              includeSkip
            />
          </div>
          <div className="matches-search-section-new vat mbm mtm">
            <div
              className="matches-search-section-inner"
              ref={this.sectionInner}
            >
              <div className="matches-search-section-inner-content mlm mrm">
                {renderSection()}
              </div>
            </div>
          </div>
        </div>
        <MatchesFooter />
      </div>
    );
  }
}

MatchesSearchMemberContainer.propTypes = {
  myId: PropTypes.string.isRequired,
  myImage: PropTypes.string,
  needAbo: PropTypes.bool,
  verificationRestrictions: PropTypes.bool,
};

MatchesSearchMemberContainer.defaultProps = {
  myImage: '',
  needAbo: false,
  verificationRestrictions: false,
};

export default MatchesSearchMemberContainer;
